import React, { useState } from 'react';
import classes from '../pages.module.css';
import { Container } from "react-bootstrap";
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';

const Alfoplus80 = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Проверенное на практике решение для частных и мобильных сетей'},
        {id:2, content: 'Прошел испытания и применяется на сетях 5G'},
        {id:3, content: 'Емкость как у оптоволоконных решений до 10G Ethernet'},
        {id:4, content: 'AES 128/256 шифрование траффика'},
        {id:5, content: 'Оптическое соединение 10G'},
        {id:6, content: 'Встроенный функционал LAG'},
        {id:7, content: 'Агрегация нескольких несущих hybrid link'},
        {id:8, content: 'Более дешевое обслуживание и быстрое время развертывания в городской среде, по сравнению с оптоволокном'}
    ])
    return(
        <>
           <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>радиорелейное оборудование</span>
                        <h1>ALFOplus80HDX</h1>
                        <p>В мобильных, фиксированных или частных сетях миллиметровые волны E-диапазона (70/80 ГГц) представляют собой новую фундаментальную технологию, сокращающую разрыв между оптоволоконными системами высокой пропускной способности и гибкой экономичной беспроводной передачей. Ёмкость, сравнимая с оптоволокном, высочайшая гибкость развертывания и работа как у традиционных РРЛ устройств, позволяют операторам использовать имеющиеся знания и навыки, экономя и одновременно модернизируя транспортную сеть. Низкая задержка и высокая пропускная способность позволяют операторам с помощью решений E-band 10 Гбит/с упростить переход на сети 5G. ALFOplus80HDX полностью уличного исполнения успешно прошел полевые испытания и уже применяется на практике для 5G backhaul.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' /> 
        </>
    )
}

export default Alfoplus80;